import { FC } from "react";

const PrivacyPage: FC = (): JSX.Element => (
  <div>
    <h1>Privacy Page</h1>
  </div>
);

export default PrivacyPage;
